export default
{
    legend: {
        enabled: true,
        layout: 'horizontal', align:'center', verticalAlign: 'bottom',  symbolRadius: 0,  symbolWidth: 10,
        itemStyle: {
            color: '#000000',
            fontWeight: 'normal',
            fontSize:'9px'
        },


    },
    credits: {
        enabled:false
    },
    chart: {
        type: 'line',
        zoomType: 'x',
        animation: false,
        height: '450px',
        spacingTop: 20,
    },
    title: null,
    xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
            //month: '%e. %b',
            month: '%m/%Y',
            year: '%b',
            hour: '%H:%M'
        },
        gridLineWidth: 1,
        gridLineColor: 'rgba(200,200,200,0.3)',
        lineColor: '#000',
        lineWidth: 1,
        tickColor: '#000',
        tickLength:5,

        tickInterval: 12 * 60 * 60 * 1000,
        minorTickInterval: 1 * 60 * 60 * 1000,

        minorGridLineColor: 'rgba(8,8,8,0.05)',

        labels: {
            rotation: 45,
            y:12,
            style:{
                fontSize:'10px'
            }
        },
        startOnTick: false,
        endOnTick: false,
        minPadding: 0,
        maxPadding: 0,
        gridZIndex:100,


    },
    yAxis: [{
        title: null,
        labels:{ x:-7 },

        minorTickInterval: 10,
        minorGridLineWidth:1,
        minorGridLineColor: 'rgba(200,200,200,0.1)',
        gridLineColor: 'rgba(200,200,200,0.2)',

        lineColor: '#000',
        lineWidth: 1,
        tickWidth: 1,
        tickInterval: 50,
        tickColor: '#000',
        gridZIndex:100,
        tickLength:5,
        min:0,
        max:450,
        plotLines: [{
            value: 400,
            color: '#009817',
            width: 1,
            zIndex: 200,
            label: {
                text: 'Signálna úroveň',
                align: 'left',
                x: 5,
                style: {
                    color: '#009817',
                    fontSize: '9px'
                }
            }
        }],
    },{
        linkedTo:0,
        opposite: true,
        title: null,
        labels:{ x:7 },
        lineColor: '#000',
        lineWidth: 1,
        tickWidth: 1,
        tickColor: '#000',
        tickLength:5,

    }],
    tooltip: {
        headerFormat: '<span style=\"font-size:10px\">{point.key}</span><table class=\"noborder\">',
        pointFormat: '<tr><td style=\"color:{series.color};padding:0;background:none;font-weight:bold;\">Hodnota radiácie: </td>' +
            '<td style=\"padding:0;background:none;color:#000\">&nbsp;<b>{point.y:.0f} nSv/h</b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true,
        backgroundColor: 'rgba(255, 255, 255, 0.85)',
        followPointer: false,
        xDateFormat: '%d.%m.%Y %H:%M'

    },

    plotOptions: {
        line: {
            animation: false,
            events: {
                legendItemClick: function () {
                    return false;
                }
            },
            marker: {
                enabled: false,
                symbol: 'square',
                radius: 2,
                states: {
                    hover: {
                        //  enabled: true,
                        lineWidthPlus: 0
                    }
                }
            },
            states: {
                hover: {
                    lineWidthPlus: 0,
                    enabled:true,
                    marker: {
                        enabled: true,
                        symbol: 'square',
                        radius: 2
                    },

                }
            }
        },
        //arearange: {
        area: {
            fillOpacity:1,
            threshold: null,
            animation: false,
            events: {
                legendItemClick: function () {
                    return false;
                }
            },
            marker: {
                enabled: false,
            },
            states: {
                hover: {

                    lineWidthPlus: 0,
                    enabled:false
                }
            }
        }

    },
    series: [{
        id:"m_radiacia",  "hidetooltip":false,
        type: "line", name:"",
        showInLegend: true,
        color:"#282A96", lineWidth:1, data:[]}
    ]
}
